module.exports = __webpack_public_path__ + "img/pointC_phone.6d84c383.png";